"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarketplaceSection = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const icons_material_1 = require("@mui/icons-material");
const react_router_dom_1 = require("react-router-dom");
const react_intl_1 = require("react-intl");
const provider_user_1 = require("@dzambalaorg/provider-user");
const types_1 = require("@framework/types");
const ui_kit_1 = require("@dzambalaorg/ui-kit");
const types_2 = require("../../../types");
const data = [
    { text: "pages.dashboard.exchange.marketplace.report", link: "/marketplace/report/search", icon: (0, jsx_runtime_1.jsx)(icons_material_1.BarChart, {}) },
    { text: "pages.dashboard.exchange.marketplace.chart", link: "/marketplace/report/chart", icon: (0, jsx_runtime_1.jsx)(icons_material_1.Timeline, {}) },
    {
        text: "pages.dashboard.exchange.marketplace.discrete",
        link: "/marketplace/report/discrete",
        icon: (0, jsx_runtime_1.jsx)(icons_material_1.Grade, {}),
    },
];
const MarketplaceSection = ({ service }) => {
    const { profile } = (0, provider_user_1.useUser)();
    const displayData = service === types_2.ServiceType.OFFICE
        ? data
        : [
            ...data,
            { text: "pages.dashboard.exchange.marketplace.rarity", link: "/marketplace/report/rarity", icon: (0, jsx_runtime_1.jsx)(icons_material_1.Hive, {}) },
        ];
    if (!profile.userRoles.includes(types_1.UserRole.ADMIN)) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(material_1.Paper, { sx: { mb: 2 }, children: (0, jsx_runtime_1.jsx)(ui_kit_1.List, { component: "nav", subheader: (0, jsx_runtime_1.jsx)(ui_kit_1.List.Subheader, { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "pages.dashboard.exchange.marketplace.title" }) }), children: displayData.map(({ text, icon, link }) => ((0, jsx_runtime_1.jsxs)(ui_kit_1.List.ItemButton, { component: react_router_dom_1.Link, to: link, children: [(0, jsx_runtime_1.jsx)(ui_kit_1.List.ItemIcon, { children: icon }), (0, jsx_runtime_1.jsx)(ui_kit_1.List.ItemText, { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: text }) })] }, text))) }) }));
};
exports.MarketplaceSection = MarketplaceSection;
//# sourceMappingURL=marketplace.js.map